export default "__VITE_ASSET__b53b3269__"